export const sortCollectionAlphabetically = <TItem>(
  collection: TItem[],
  keyGetter?: (item: TItem) => string
) =>
  [...collection].sort((itemA, itemB) => {
    if (!keyGetter && typeof itemA !== "string") {
      throw new Error(
        "keyGetter is required when collection items are not strings"
      );
    }

    const keyA = keyGetter?.(itemA) || (itemA as string);
    const keyB = keyGetter?.(itemB) || (itemB as string);

    if (!keyA && !keyB) return 0;
    if (!keyA) return 1;
    if (!keyB) return -1;

    return keyA.toUpperCase().localeCompare(keyB.toUpperCase());
  });
